<ng-container *ngIf="data$ | async as data; else loader">
  <app-liabilities-delegate
    [liability]="data.liability"
    [customerBiller]="data.customerBiller"
  ></app-liabilities-delegate>
</ng-container>
<ng-template #loader>
  <app-loading></app-loading>
</ng-template>
